<template>
  <swiper ref="awesomeSwiper2" :options="swiperOption">
    <swiper-slide  v-for="item in list" :key="item.img">
        <div @click="gotoUrl(item)">
          <a :href="item.url" :ref="item.id" style="display:none;"></a>
          <img :src="item.img" >
        </div>
    </swiper-slide>
  <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
  <!-- <div class="swiper-button-next" slot="button-next"></div> -->
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';

import 'swiper/dist/css/swiper.min.css';//eslint-disable-line

export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    swiper() {
      return this.$refs.awesomeSwiper2.swiper;
    },
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        loop: false, // 目前一张人保乘驾险的图 就不用轮播了
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
      },
    };
  },
  methods: {
    gotoUrl(item) {
      // _czc.push(['_trackEvent', 'banner', item.name+'', '','','']); //eslint-disable-line
      console.log(this.$refs[item.id], item.id);
      this.$refs[item.id] && this.$refs[item.id].click&&this.$refs[item.id].click();//eslint-disable-line
      this.$refs[item.id] && this.$refs[item.id][0] && this.$refs[item.id][0].click&&this.$refs[item.id][0].click();//eslint-disable-line
    },
  },
};
</script>

<style scoped>
.swiper-container {
  /* margin-bottom: 10px; */
}
</style>
